import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const keyIngredients: MediaContentShowcaseItem[] = [
    {
        image: `Ingredient-1.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Fish Oil",
        summary:
            'Omega-3 fatty acids (EPA and DHA) derived from fish.',
        detail:
            'Fish oil has been suggested to support heart and brain health, as well as maintain healthy skin and \
            connective tissue.<span class="oui-sup">&dagger;</span> Various health organizations recommend consuming \
            at least 250 mg of EPA and DHA combined daily.<span class="oui-sup">1</span>',
    },
    {
        image: `Ingredient-2.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Borage Seed Oil',
        summary: 'A plant-derived source of gamma-linoleic acid (GLA), a type of omega-6 fatty acid.',
        detail: 'The combination of borage and fish oil contributes to overall joint health and function.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `Ingredient-3.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Avocado Soybean Unsaponifiables',
        summary: 'A plant-based extract from avocado and soybean oil.',
        detail: 'Supports the body’s normal joint tissue repair process.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `Ingredient-4.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Turmeric Root Extract',
        summary: 'A spice popular in Indian cuisine, turmeric has been used in Ayurvedic and Chinese health practices for ages.',
        detail: 'Turmeric contains curcumin, a compound with antioxidant properties.<span class="oui-sup">&dagger;</span>',
    },
];

export default keyIngredients;
